namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import ISoundManager = Roodik.Core.ISoundManager;
	import Easing = Roodik.Core.Tween.Easing;
	import Tween = Roodik.Core.Tween.Tween;
	import Timer = Roodik.Core.Timer;
	import LocalizationManager = Roodik.Core.LocalizationManager;
	import IAnalytics = Roodik.Core.IAnalytics;

	export class LevelCompletePanel extends ViewBase
	{
		private _closePanel:()=>void;
		private _timerShow:Timer;
		private _timeShow:number = 3;
		private _timeOut:number = 0;
		private _message : PIXI.Text;
		private _progress : PIXI.Text;

		constructor(private _localizationManager:LocalizationManager,
		            private _soundManager:ISoundManager,
		            private _finishedLevel:number,
		            private _countLevels:number,
		            private _analytics:IAnalytics,
		            closeCallBack:()=>void)
		{
			super("LevelCompletePanel");

			this._analytics.sendEvent("Level_"+this._finishedLevel + "/"+this._countLevels+"","Complete","");

			this.alpha = 0;
			this.y = 300;

			this.createTitle();
			this.createProgress();

			this._closePanel = () => {
				closeCallBack();
			};

			this._timerShow = new Timer((tick:number)=>
			{
				if (this._timeOut >= this._timeShow)
				{
					this._timerShow.stop();
					this.hide();
				}
				else
				{
					this._timeOut++;
				}
			});
			this._timerShow.stop();

			this.show();
		}

		private createTitle()
		{
			this._message = new PIXI.Text(this._localizationManager.getString(LocalizationKey.HOORAY),
			{
				fontFamily: 'WellWait',
				fontSize: 70,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: ['#FFA500', '#FFD700'],//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: '#ffffff',//'#338d13',
				strokeThickness: 5,

				dropShadow: true,
				dropShadowColor: '#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			});
			this._message.x = -this._message.width*0.5;
			this._message.y = -240;
			this.addChild(this._message);
		}

		private createProgress()
		{
			this._progress = new PIXI.Text(this._finishedLevel+" / "+this._countLevels +this._localizationManager.getString(LocalizationKey.LEVEL_COMPLETE_DESCRIPTION),
			this.titleStyle(50, ['#ffffff', ], '#000000', "center",1));
			this._progress.x = -this._progress.width*0.5;
			this._progress.y = -80;
			this.addChild(this._progress);
		}

		private titleStyle(fontSize:number, fillColor:any, strokeColor:string, align:string = "center", strokeThickness:number = 5)
		{
			return {
				fontFamily: 'WellWait',
				fontSize: fontSize,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: fillColor,//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: strokeColor,//'#ffffff',//'#338d13',
				strokeThickness: 5,
				align:align,
				dropShadow: true,
				dropShadowColor: strokeColor,//'#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			}
		}

		private show()
		{
			this._soundManager.playSound("levelComplete.wav", 1);


			let properties = {alpha:this.alpha, y:this.y};
			new Tween(properties)
			.to({alpha: 1, y: 0}, 150)
			.easing(Easing.Quadratic.In)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(()=>{
				this._timerShow.start();
			})
			.start();
		}

		private hide()
		{
			let properties = {alpha:this.alpha,y:this.y};
			new Tween(properties)
			.to({alpha: 0, y: -300}, 150)
			.easing(Easing.Quadratic.Out)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(function ()
			{
				Tween.removeAll();
				this._closePanel();
			}.bind(this))
			.start();
		}

		public destroy()
		{
			this.removeChild(this._message);
			this.removeChild(this._progress);
			this._message.destroy();
			this._progress.destroy();

			this._timerShow.stop();
			this._timerShow.destroy();
			this._timerShow = null;

			this._closePanel = null;

			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/LevelCompletePanel.ts